const fetchVehicleUseCase = (repository) => async (pagination, search, status, includeID, includeIDs) => {
    const payload = {
        sort: pagination.sortBy.map((s) => [s]).join(','),
        descending: pagination.sortDesc.join(','),
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
        search: search,
        status: status,
        includeID: includeID,
        includeIDs: includeIDs,
    }
    return await repository(payload);
}

export default fetchVehicleUseCase;